export const LOADING = 'app.loading';
export const ERROR_404 = 'app.error404';
export const ERROR_500 = 'app.error500';
export const OK = 'app.ok';
export const PAGE_LOAD_ERROR = 'app.page.loadError';
